var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from "react";
import warning from "warning";
import { FilterChipsContainer } from "./filterchips.styles";
import { Chip } from "../chip";
import { hasTitle, isSelected, hasIcon, getNewSelectedItems } from "./helpers";
export class FilterChips extends React.Component {
    constructor(props) {
        super(props);
        this.renderChips = () => {
            const { chips, selectedItems, type, chipMinWidth = 200, gap, onChange, isShowLabel, previewIdExtractor, } = this.props;
            const { selectedChips } = this.state;
            const selected = selectedItems || selectedChips;
            let chipsToRender = chips ? [...chips] : [];
            const chipslength = chipsToRender.length;
            if (type === "A") {
                chipsToRender = chipsToRender.filter((c) => hasTitle(c) && isSelected(selected, c));
            }
            if (type === "B") {
                chipsToRender = chipsToRender.filter((c) => hasTitle(c) || hasIcon(c));
                warning(chipslength === chipsToRender.length, `empty chip - type-B chip needs at least a title or an icon`);
            }
            return chipsToRender.map((_a, index) => {
                var { title, icon, disabled, value } = _a, restProps = __rest(_a, ["title", "icon", "disabled", "value"]);
                return (_createElement(Chip, Object.assign({}, restProps, { chipMinWidth: chipMinWidth, gap: gap, value: value, type: type, disabled: disabled, icon: icon, key: value, title: title, isShowLabel: isShowLabel, selected: selected.indexOf(value) >= 0, onChange: (chipIndex) => {
                        if (disabled) {
                            return;
                        }
                        const newSelectedItems = getNewSelectedItems(selected, chipIndex);
                        if (onChange) {
                            onChange(newSelectedItems);
                        }
                        this.setState({
                            selectedChips: getNewSelectedItems(selected, chipIndex),
                        });
                    } })));
            });
        };
        const { defaultSelectedChips } = props;
        this.state = {
            selectedChips: defaultSelectedChips,
        };
    }
    reset() {
        const { defaultSelectedChips, onChange } = this.props;
        this.setState({ selectedChips: defaultSelectedChips });
        if (onChange) {
            onChange(defaultSelectedChips);
        }
    }
    render() {
        const { gap = 16, isStrechedWidth, previewId } = this.props;
        return (_jsx(FilterChipsContainer, Object.assign({ gap: gap, "data-preview-id": previewId, isStrechedWidth: isStrechedWidth }, { children: this.renderChips() })));
    }
}
